import { useEffect, useRef, useState } from "preact/hooks";

/**
 * Число, которое плавно догоняет `target` за `ms` (счётчик монет). Уменьшение (трата, откат) — сразу.
 * Возвращает показываемое значение и счётчик «приходов» (растёт на каждое увеличение — ключ для анимации).
 */
export function useTweenedNumber(target: number, ms = 450): { value: number; bumps: number } {
  const [value, setValue] = useState(target);
  const [bumps, setBumps] = useState(0);
  const from = useRef(target);
  const shown = useRef(target);
  const prev = useRef(target);

  useEffect(() => {
    if (target === prev.current) return;
    const up = target > prev.current;
    prev.current = target;
    if (!up || typeof requestAnimationFrame === "undefined") {
      shown.current = target;
      setValue(target);
      return;
    }
    setBumps((b) => b + 1);
    from.current = shown.current;
    const start = performance.now();
    let raf = 0;
    const tick = (now: number) => {
      const k = Math.min(1, (now - start) / ms);
      const eased = 1 - (1 - k) * (1 - k);
      shown.current = Math.round(from.current + (target - from.current) * eased);
      setValue(shown.current);
      if (k < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, ms]);

  return { value, bumps };
}
